import React, { FC, useEffect, useRef, useState } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import cx from 'classnames';

import { ORIENTATION_ANGLE } from '../../../commons/constants';
import { storeName } from '../../../redux/models/layout.model';

import './styles.scss';

const RotateDevice: FC = () => {
  const intl: IntlShape = useIntl();

  const [isShow, setIsShow] = useState<boolean>(false);
  const [transitionFlag, setTransitionFlag] = useState<boolean>(false);

  const isMobileDevice = useSelector((state) => state[storeName].isMobileDevice);
  const isTabletDevice = useSelector((state) => state[storeName].isTabletDevice);
  const orientationAngle = useSelector((state) => state[storeName].orientationAngle);

  const timeout = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    if (!isMobileDevice || !orientationAngle) return;

    if (isMobileDevice && orientationAngle === ORIENTATION_ANGLE.LANDSCAPE) {
      if (transitionFlag) setTransitionFlag(false);
      if (timeout.current) {
        clearTimeout(timeout.current);
        timeout.current = null;
      }

      setIsShow(true);
    } else if (isMobileDevice && orientationAngle === ORIENTATION_ANGLE.PORTRAIT) {
      setTransitionFlag(true);
    }
  }, [isMobileDevice, isTabletDevice, orientationAngle]);

  useEffect(() => {
    if (!transitionFlag) return;

    timeout.current = setTimeout(() => {
      setTransitionFlag(false);
      setIsShow(false);
    }, 1000);
  }, [transitionFlag]);

  if (!isShow) return null;
  return (
    <div
      className={cx('bds-rotate-device__wrapper', {
        'bds-rotate-device__wrapper--mobile': isMobileDevice,
        'bds-rotate-device__wrapper--transition': transitionFlag,
      })}
    >
      <div className="rotate-device__content">
        {isMobileDevice && (
          <>
            <i className="icon-iphone_rotate_300x300"></i>
            <div className="content__msg">
              <span>{intl.formatMessage({ id: 'please-rotate-device.mobile.content.msg' })}</span>
            </div>
            <div className="content__description">
              <span>
                {intl.formatMessage({ id: 'please-rotate-device.mobile.content.description' })}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(RotateDevice);
